export const persianDigitWithSeprator = (input) => {
  if (input === null || input === undefined) return "";

  const str = input.toString();

  // normalize Persian digits to English
  const normalized = str.replace(
    /[۰-۹]/g,
    (d) => "0123456789"["۰۱۲۳۴۵۶۷۸۹".indexOf(d)],
  );

  // find number only
  const match = normalized.match(/\d+(?:,\d{3})*(?:\.\d+)?/);
  if (!match) return str;

  const formatted = Number(match[0].replace(/,/g, "")).toLocaleString("en-US");

  const persianFormatted = formatted.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

  // replace ONLY the matched number
  return str.replace(match[0], persianFormatted);
};
